module.exports = __webpack_public_path__ + "img/01.6b7f4df0.jpg";